import React from 'react';
import Show from '@/newcar/ui/molecule/Show';
import { StandardProps } from '@/newcar/ui/contract';
import * as styles from './index.module.styl';

interface SelectProps extends StandardProps {
  id: string;
  label: string;
  defaultValue?: string;
  helperText?: string;
  items: {
    label: string;
    value: string | number | null;
    isDisabled?: boolean;
  }[];
  errorMessage?: string;
  value: string | number;
  onFocus?: (event: React.FocusEvent<HTMLSelectElement>) => void | Promise<void>;
  onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
  onBlur(event: React.ChangeEvent<HTMLSelectElement>) : void;
}

// 申込みフォームの選択式メニュー
export default function Select(props: SelectProps): JSX.Element {
  const {
    id,
    label,
    className = '',
    defaultValue = '',
    helperText = '',
    items,
    errorMessage = '',
    value,
    onFocus,
    onChange,
    onBlur,
  } = props;

  // Functions
  function isRequired(): 'true' | 'false' | undefined {
    if (value !== '' && value !== null) {
      return 'false';
    }
    if (errorMessage === '' && (value === '' || value === null)) {
      return undefined;
    }
    if (value === '') {
      return 'true';
    }
    return undefined;
  }
  function isErrDisplay(): 'true' | 'false' | undefined {
    if (errorMessage !== '') {
      return 'true';
    }
    if (errorMessage === '' && (value === '' || value === null)) {
      return undefined;
    }
    if (errorMessage === '' && (value !== '' || value !== null)) {
      return 'false';
    }
    return undefined;
  }

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event);
    onBlur(event);
  };

  return (
    <div className={`${className}`}>
      <div className={`is-margin-bottom-3 ${styles.labelHeight}`}>
        {label}
        <Show when={helperText !== ''}>
          <p className="is-size-6 is-margin-top-1">
            {helperText}
          </p>
        </Show>
      </div>
      <div
        className={`${styles.pFormField} ${styles.cSelect}`}
        aria-invalid={isErrDisplay()}
        aria-required={isRequired()}
      >
        <div className={styles.cSelectBody}>
          <select
            className="is-size-4"
            id={id}
            defaultValue={defaultValue}
            data-gtm={`gtm-newcarform-${id}`}
            onChange={handleChange}
            onFocus={onFocus}
          >
            {
              items.map((item) => (
                <option key={`${id}-${item.value}`} value={item.value ?? ''} disabled={item.isDisabled}>
                  {item.label}
                </option>
              ))
            }
          </select>
          <i className={styles.iconPulldown} />
        </div>
      </div>
      <Show when={errorMessage !== ''}>
        <div className="columns is-mobile is-padding-top-1">
          <div className="column is-paddingless"><p className="has-text-weight-bold is-size-6 has-text-danger">{errorMessage}</p></div>
        </div>
      </Show>
    </div>
  );
}
